import Dice1 from '@static/images/dice_1.svg';
import Dice2 from '@static/images/dice_2.svg';
import Dice3 from '@static/images/dice_3.svg';
import Dice4 from '@static/images/dice_4.svg';
import Dice5 from '@static/images/dice_5.svg';
import Dice6 from '@static/images/dice_6.svg';
export const DICE_FACES = [
    {
        value: 1,
        image: Dice1
    },
    {
        value: 2,
        image: Dice2
    },
    {
        value: 3,
        image: Dice3
    },
    {
        value: 4,
        image: Dice4
    },
    {
        value: 5,
        image: Dice5
    },
    {
        value: 6,
        image: Dice6
    }
];
export const ALL_DICE_ROLLS = DICE_FACES.map((diceFace)=>diceFace.value);
export const INITIAL_DICE_FACE = DICE_FACES[DICE_FACES.length - 1];
